import React from "react";
import SortlistedCandidates from "../sortlistedCandidates";
import { constants } from "../../../../constants/common";
const LevelOne = () => {
    return <SortlistedCandidates level={constants.PROFILE_STATUS.LEVEL_1} />
}

export default LevelOne;